import React, { useEffect, useState } from "react";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerTrigger,
} from "@/src/components/ui/Drawer";
import InfoIcon from "@/src/assets/InfoIcon";
import { useDispatch } from "react-redux";
import { requestFlightTourneyQualifiedPlayers } from "@/Poker/redux/slices/lobbySlice";
import useGetSingleTourneyDefinitionById from "@/src/hooks/data/useGetSingleTourneyDefinitionById";
import { usePlayer } from "@/src/hooks/data/useLobby";

const QualifiedPlayerSheet = ({ stackDetails, tourneyDetails }) => {
  const dispatch = useDispatch();
  const [open, setopen] = useState(false);
  const player = usePlayer();
  const tourney = useGetSingleTourneyDefinitionById(tourneyDetails?.tourneyId);

  //   console.log("qualified: ", tourney?.qualifiedPlayers, player);
  useEffect(() => {
    if (open) {
      dispatch(
        requestFlightTourneyQualifiedPlayers({
          tourneyId: tourneyDetails.tourneyId,
        })
      );
    }
  }, [open]);

  return (
    <Drawer onOpenChange={(value) => setopen(value)}>
      <DrawerTrigger>
        <div className="flex flex-col items-center justify-center">
          <div className="text-secondary text-2xs">Qualified Players</div>
          <div className="flex items-center">
            <div className="text-success font-medium mt-1 text-2xs mr-1">
              {stackDetails?.numberOfQualifiedPlayers || 0}
            </div>
            <InfoIcon clr={"#42BE40"} />
          </div>
        </div>
      </DrawerTrigger>
      <DrawerContent side="bottom">
        {tourney?.qualifiedPlayers?.length > 0 ? (
          <div className="bg-linear-to-b from-foreground to-background to-80%">
            <h2 className="text-xs p-3 text-center border-b border-b-main font-medium">
              Qualified Players
            </h2>
            <div className="max-h-[50vh] border border-b-main m-3 text-secondary rounded-300 overflow-y-auto">
              <div className="flex border-b p-3 border-b-main flex-row items-center text-xs">
                <p className="basis-3/12">Position</p>
                <p className="basis-6/12">Name</p>
                <p className="basis-3/12 text-right">Stack</p>
              </div>
              <ul className="">
                {tourney?.qualifiedPlayers
                  .filter((pl) => pl.displayName === player.displayName)
                  .map((player, index) => (
                    <div
                      className={`flex ${
                        index !== 0 ? "border-t" : ""
                      } border-b-main py-3 px-4 bg-accent flex-row items-center text-primary text-sm`}
                    >
                      <p className="basis-3/12">{player.rank}</p>
                      <p className="basis-6/12">{player.displayName}</p>
                      <p className="basis-3/12 text-right">
                        {player.chipStack}
                      </p>
                    </div>
                  ))}
                {tourney?.qualifiedPlayers
                  .filter((pl) => pl.displayName !== player.displayName)
                  .map((player, index) => (
                    <div
                      className={`flex ${
                        index !== 0 ? "border-t" : ""
                      } border-b-main m-2 py-2 px-3 flex-row items-center text-xs`}
                    >
                      <p className="basis-3/12">{player.rank}</p>
                      <p className="basis-6/12">{player.displayName}</p>
                      <p className="basis-3/12 text-right">
                        {player.chipStack}
                      </p>
                    </div>
                  ))}
              </ul>
            </div>
          </div>
        ) : (
          <div className="p-4 max-h-[50vh] text-center text-secondary">
            No players have qualified for this tournament yet.
          </div>
        )}
        {/* <DrawerClose onClick={() => handleQualifiedClose(false)} /> */}
      </DrawerContent>
    </Drawer>
  );
};

export default QualifiedPlayerSheet;
